export const FETCH_ITEMS = "FETCH_ITEMS"
export const FILTER_ITEMS = "FILTER_ITEMS"

export const ADD_ITEM = "ADD_ITEM"
export const REMOVE_ITEM = "REMOVE_ITEM"

export const INCREASE_QUANTITY = "INCREASE_QUANTITY"
export const DECREASE_QUANTITY = "DECREASE_QUANTITY"

export const CLEAR_CART = "CLEAR_CART"